import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './ComposerButton.constants';

export const composerButtonDriverFactory = (base: UniDriver) => {
  const buttonBaseElement = findByHook(base, dataHooks.button);
  const buttonCoreDriver = buttonCoreDriverFactory(buttonBaseElement);

  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether button is disabled
     * @returns {Promise<boolean>}
     */
    isDisabled: buttonCoreDriver.isButtonDisabled,

    /**
     * Returns button label value
     * @returns {Promise<string>}
     */
    getLabelValue: buttonCoreDriver.getButtonTextContent,

    /**
     * Checks whether button is focused
     * @returns {Promise<boolean>}
     */
    isFocused: buttonCoreDriver.isFocused,
  };
};

export type ComposerButtonUniDriver = ReturnType<
  typeof composerButtonDriverFactory
>;
